import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import WorkflowService from '../../services/WorkflowService';

export const getWorkflows = createAsyncThunk('workflows/getWorkflows', async (workspaceId) =>
    WorkflowService.getWorkflows(workspaceId),
);

export const createWorkflow = createAsyncThunk('workflows/create', async (data) =>
    WorkflowService.createWorkflow(data),
);

export const updateWorkflow = createAsyncThunk('workflows/update', async ({ id, data }) =>
    WorkflowService.updateWorkflow(id, data),
);

export const deleteWorkflow = createAsyncThunk('workflows/delete', async (id) => {
    await WorkflowService.deleteWorkflow(id);
    return id;
});

export const runWorkflow = createAsyncThunk('workflows/run', async ({ id, input }) =>
    WorkflowService.runWorkflow(id, input),
);

const initialState = {
    list: [],
    loading: false,
    error: null,
    runResult: null,
    running: false,
};

const upsert = (list, item) => {
    const idx = list.findIndex((w) => w._id === item._id);
    if (idx === -1) return [item, ...list];
    const next = [...list];
    next[idx] = item;
    return next;
};

const WorkflowSlice = createSlice({
    name: 'workflows',
    initialState,
    reducers: {
        clearRunResult: (state) => { state.runResult = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWorkflows.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getWorkflows.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload || [];
            })
            .addCase(getWorkflows.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(createWorkflow.fulfilled, (state, action) => {
                if (action.payload) state.list = upsert(state.list, action.payload);
            })
            .addCase(createWorkflow.rejected, (state, action) => {
                state.error = action.error.message;
            });

        builder
            .addCase(updateWorkflow.fulfilled, (state, action) => {
                if (action.payload) state.list = upsert(state.list, action.payload);
            })
            .addCase(updateWorkflow.rejected, (state, action) => {
                state.error = action.error.message;
            });

        builder
            .addCase(deleteWorkflow.fulfilled, (state, action) => {
                state.list = state.list.filter((w) => w._id !== action.payload);
            });

        builder
            .addCase(runWorkflow.pending, (state) => { state.running = true; state.runResult = null; })
            .addCase(runWorkflow.fulfilled, (state, action) => {
                state.running = false;
                state.runResult = action.payload;
            })
            .addCase(runWorkflow.rejected, (state, action) => {
                state.running = false;
                state.error = action.error.message;
            });
    },
});

export const { clearRunResult } = WorkflowSlice.actions;

export const selectWorkflows = (state) => state.workflows.list;
export const selectWorkflowsLoading = (state) => state.workflows.loading;
export const selectWorkflowsError = (state) => state.workflows.error;
export const selectRunResult = (state) => state.workflows.runResult;
export const selectRunning = (state) => state.workflows.running;

export default WorkflowSlice.reducer;
